import { render } from "./worker_update.vue?vue&type=template&id=4dfbe1fe"
import script from "./worker_update.vue?vue&type=script&lang=js"
export * from "./worker_update.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__